export class MenuTitleDescriptionModel {
  id: number;
  menu_item_id: number;
  title: string;
  description: string;
  select_values: string;
  reason_values: string;
  closing_values: string;
  date_required: boolean;
  image_url: string;
  image_name: string;
  hotel_id: number;


  constructor(id = 0,
              menu_item_id = 0,
              title = '',
              description = '',
              image_url = '',
              image_name = '',
              select_values = '',
              reason_values = '',
              closing_values = '',
              date_required = false,
              hotel_id = 0) {
    this.id = id;
    this.menu_item_id = menu_item_id;
    this.title = title;
    this.description = description;
    this.select_values = select_values;
    this.reason_values = reason_values;
    this.closing_values = closing_values;
    this.date_required = date_required;
    this.image_url = image_url;
    this.image_name = image_name;
    this.hotel_id = hotel_id;
  }
}
